export default __webpack_public_path__ + "static/media/screen2.5a78df67.png";